import minMaxBuildValues from "./_min-max-build-values.js";

const minMaxFilter = function (cell, onRendered, success, cancel, editorParams) {
  function buildValues(e) {
    return minMaxBuildValues(start.value, end.value, success, cancel);
  }

  const container = document.createElement("div");
  container.classList.add("min-max-filter");

  //create and style inputs
  const start = document.createElement("input");
  //start.setAttribute("type", "number");

  start.setAttribute("placeholder", "Min");

  const end = document.createElement("input");
  //end.setAttribute("type", "number");
  end.setAttribute("placeholder", "Max");

  start.addEventListener("change", buildValues);
  end.addEventListener("change", buildValues);

  container.appendChild(start);
  container.appendChild(end);

  return container;
};

export default minMaxFilter;
